import { render, staticRenderFns } from "./CadastroPaciente.vue?vue&type=template&id=5c806276&"
import script from "./CadastroPaciente.vue?vue&type=script&lang=js&"
export * from "./CadastroPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports